import type { PlacementContact } from '@duke-hq/svc-api/admin/trpc/routers/workPlacements/placements/schemas';
import type {
  EmployerContactFormValues,
  EmployerContactInput,
} from '@duke-hq/svc-api/admin/trpc/routers/workPlacements/employers/schemas';

export type EmployerContactChoice =
  | { mode: 'none' }
  | { mode: 'existing'; contactId: string }
  | { mode: 'new'; contact: EmployerContactFormValues };

export type ChosenEmployerContact = Exclude<EmployerContactChoice, { mode: 'none' }>;

export const noContactChoice: EmployerContactChoice = { mode: 'none' };

export const emptyNewContact: EmployerContactFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  preferredContactMethod: '',
  isPrimary: false,
};

function toNullable(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}

function toContactInput(contact: EmployerContactFormValues): EmployerContactInput {
  return {
    firstName: contact.firstName.trim(),
    lastName: contact.lastName.trim(),
    email: toNullable(contact.email),
    phone: toNullable(contact.phone),
    preferredContactMethod:
      contact.preferredContactMethod === '' ? null : contact.preferredContactMethod,
  };
}

export function toPlacementContact(choice: ChosenEmployerContact): PlacementContact {
  switch (choice.mode) {
    case 'existing':
      return { contactId: choice.contactId };
    case 'new':
      return {
        newContact: toContactInput(choice.contact),
        saveAsPrimary: choice.contact.isPrimary,
      };
  }
}
